<template>
	<div class="content">
		<div class="left" v-show="showChildren">
			<span :style="{color:(this.showTitleColor?'#000':'#fff')}">当前儿童</span>
			<el-select v-model="currentValue" :disabled='disabled' @change="select" placeholder="请选择" :popper-append-to-body="false" @visible-change="visibleChange">
				<el-option
					v-for="item in children"
					:key="item.id"
					:label="item.studentName"
					:value="item.id"
				>
				</el-option>

			</el-select>
			<div class="trangle">
				<div class="trangle_wrap">
					<img src="../../assets/images/parent-course/org-trangle.png" alt="" :class='{active:arrroStyle}' v-if="typeCateegory!=2 || !typeCateegory">
					<img src="../../assets/images/parent-course/gray_trangle.png" alt="" :class='{active:arrroStyle}' v-if="typeCateegory==2">
				</div>
			</div>
		</div>
		<div class="growthRecord" @click="growthRecord" v-show="showTitle">
			{{btnTitle}}
		</div>
	</div>
</template>

<script>
export default {
	name: 'present-children',
	props: {
		showTitleColor: {
			type: Boolean,
			default: true
		},
		// 下拉箭头的种类，当为2的时候灰色，禁用状态
		typeCateegory: [Number, String],
		btnTitle: {
			type: String,
		},
		children: {
			type: Array,
		},
		value: {
			type: String,
		},
		showTitle: {
			type: Boolean,
			default: true
		},
		showChildren: {
			type: Boolean,
			default: true
		},
		disabled: {
			type: Boolean,
			default: false
		},
	},
	data() {
    return {
		currentValue: this.value,
		arrroStyle: false,
    }
  },
	methods:{
		growthRecord(){
			this.$emit('growthRecord');
		},
		select(){
			this.$emit('select',this.currentValue);
		},
		// 控制下拉框箭头的样式
		visibleChange() {
			this.arrroStyle = !this.arrroStyle
		},
	},
}
</script>

<style lang="scss" scoped>
::v-deep .el-select{
	width: 111px;
	height: 26px;
}
::v-deep .el-input__suffix {
	display: none;
}
::v-deep .el-input__inner{
	width: 111px;
	height: 26px;
	border: none;
	box-shadow: 0px 1px 4px 0px rgba(203, 203, 203, 0.5);
	border-radius: 6px;
	color: #FF7F30;
	margin-left: 10px;
	line-height: 26px;
}
::v-deep .el-select .el-input .el-select__caret{
  color:#FF7F30;
}::v-deep .el-select-dropdown__item.selected{
	color:#FF7F30;
}
::v-deep li.el-select-dropdown__item.selected.hover {
	height: 22px;
	line-height: 22px;
}
::v-deep li.el-select-dropdown__item.selected {
	height: 22px;
	line-height: 22px;
}
.content{
	padding: 0 10px;
	line-height: 40px;
	.left{
		position: relative;
		width: 240px;
		float: left;
		display: flex;
		span {
			font-size: 14px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #666666;
			line-height: 40px;
		}
		.trangle {
			position: absolute;
			right: 30%;
			top: 40%;
			.trangle_wrap {
				width: 10px;
				height: 7px;
				img {
					transition:all .2s linear;
					width: 100%;
					height: 100%;
					&.active {
						transform: rotate(180deg);
					}
				}

			}
		}
	}

	.growthRecord{
		width: 85px;
		height: 28px;
		background: linear-gradient(90deg, #FA709A 0%, #FFBB87 100%);
		box-shadow: 0px 2px 6px 0px #CA4A44;
		border-radius: 15px;
		color: #fff;
		line-height: 28px;
		font-size: 14px;
		text-align: center;
		float: right;
		margin-top: 5px;
	}

	.el-scrollbar {
		> .el-scrollbar__bar {
			opacity: 1 !important;
		}
	}
}
</style>
